import { render, staticRenderFns } from "./BsGridToolSearch.vue?vue&type=template&id=012fdac7&scoped=true&"
import script from "./BsGridToolSearch.vue?vue&type=script&lang=js&"
export * from "./BsGridToolSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012fdac7",
  null
  
)

export default component.exports